import {Tag, TagColor} from '@benchling/nucleus-ui';
import React from 'react';

import {FieldDataMigrationStatus} from 'graphql-client/__generated/graphqlGlobalTypes';

const STATUS_DISPLAY: Record<FieldDataMigrationStatus, {text: string; color: TagColor}> = {
  [FieldDataMigrationStatus.PENDING]: {text: 'Pending', color: TagColor.SECONDARY},
  [FieldDataMigrationStatus.SUCCEEDED]: {text: 'Succeeded', color: TagColor.SUCCESS},
  [FieldDataMigrationStatus.PUBLISHED]: {text: 'Published', color: TagColor.DEFAULT},
  [FieldDataMigrationStatus.FAILED]: {text: 'Failed', color: TagColor.ERROR},
  [FieldDataMigrationStatus.CANCELLED]: {text: 'Cancelled', color: TagColor.WARN},
};

export function AntibodyFieldMigrationStatusTag({status}: {status: FieldDataMigrationStatus}): JSX.Element {
  const {text, color} = STATUS_DISPLAY[status];
  return <Tag color={color} text={text} />;
}
